export const environment = {
    baseURL: 'https://api.meridianguru.org/'
    // baseURL: 'http://localhost:6900/'
}